import { Injectable } from "@angular/core";
import { HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { VERSION } from "../app.config";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const token = this.getToken(req);
    if (token) {
      const authReq = req.clone({
        headers: req.headers.set('Authorization', token).set('X-Admin-Voyager-Version', VERSION)
      });
      return next.handle(authReq);
    } else {
      const unauthenticatedReq = req.clone({
        headers: req.headers.set('X-Admin-Voyager-Version', VERSION)
      });
      return next.handle(unauthenticatedReq);
    }
  }

  getToken(req: HttpRequest<any>): string {
    const userToken = localStorage.getItem('token');
    const adminToken = localStorage.getItem('adminToken');
    let voyagerOrigin = req.headers.get('x-voyager-origin');
    if (voyagerOrigin === 'external') {
      const token = userToken || adminToken;
      return `Bearer ${token}`
    }
    if (!voyagerOrigin && adminToken) voyagerOrigin = 'ptc';
    else if (!voyagerOrigin) return null;
    return voyagerOrigin === 'ptc' ? adminToken : userToken;
  }
}



// WEBPACK FOOTER //
// ./src/app/http-interceptors/auth-interceptor.ts